import { useState, useCallback } from 'react';
import {
  fetchSignature as fetchSignatureApi,
  saveSignature as saveSignatureApi,
  uploadSignatureImage as uploadSignatureImageApi,
  Signature
} from '../../../../services/messageService';

export function useSignature() {
  const [signature, setSignature] = useState<Signature | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSignature = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetchSignatureApi();
      setSignature(res);
    } catch (e: any) {
      setSignature(null);
      if (e.response?.data?.code === 'SIGNATURE_NOT_FOUND') {
        setError('No signature found.');
      } else {
        setError(e.message || 'Failed to fetch signature.');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const saveSignature = useCallback(async (html: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await saveSignatureApi(html);
      setSignature(res);
      return res;
    } catch (e: any) {
      setError(e.message || 'Failed to save signature.');
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  const uploadSignatureImage = async (file: File): Promise<string> => {
    return await uploadSignatureImageApi(file);
  };

  return {
    signature,
    loading,
    error,
    fetchSignature,
    saveSignature,
    setSignature,
    uploadSignatureImage,
  };
}
